export default "__VITE_ASSET__6eb60a1a__"